import { Feature } from "ol"
import { Extent } from "ol/extent"
import Geometry from "ol/geom/Geometry"
import Polygon from "ol/geom/Polygon"
import VectorLayer from "ol/layer/Vector"
import VectorSource from "ol/source/Vector"
import Fill from "ol/style/Fill"
import Stroke from "ol/style/Stroke"
import Style from "ol/style/Style"
import { BoundingBox, IBoundingBox } from "./OcrTypes"


export type BoundArea = {
	color: string
	borderWidth: number
	fillColor?: string
} & IBoundingBox

export const createLayer = () => {
	console.log('creating layer!!!')

	const vectorSource = new VectorSource()
	return new VectorLayer({ source: vectorSource })
}

export const createExtent = (boundingBoxCoordinates: BoundingBox, imageExtent: Extent, ocrExtent: Extent): Extent => {

	const coordinates = getCoordinates(boundingBoxCoordinates, imageExtent, ocrExtent)

	const xValues = [coordinates[0].x, coordinates[1].x, coordinates[2].x, coordinates[3].x]
	const yValues = [coordinates[0].y, coordinates[1].y, coordinates[2].y, coordinates[3].y]

	const fieldExtent: Extent = [
		Math.min(...xValues),
		Math.min(...yValues),
		Math.max(...xValues),
		Math.max(...yValues)
	]

	return fieldExtent
}

export const getCoordinates = (boundingBoxCoordinates: BoundingBox, imageExtent: Extent, ocrExtent: Extent): BoundingBox => {

	const imageWidth = imageExtent[2] - imageExtent[0]
	const imageHeight = imageExtent[3] - imageExtent[1]
	const ocrWidth = ocrExtent[2] - ocrExtent[0]
	const ocrHeight = ocrExtent[3] - ocrExtent[1]

	const internalBoundingBox: BoundingBox = []

	for (let i = 0; i < boundingBoxCoordinates.length; i++) {
		internalBoundingBox.push({
			x: (boundingBoxCoordinates[i].x / ocrWidth) * imageWidth,
			y: (1 - (boundingBoxCoordinates[i].y / ocrHeight)) * imageHeight
		})
	}

	return internalBoundingBox
}

export const createBoundingBoxFeature = (boundArea: BoundArea, imageExtent: Extent, ocrExtent: Extent): Feature<Geometry> => {

	const coordinates = getCoordinates(boundArea.boundingBox, imageExtent, ocrExtent)

	const mappedCoordinates = [
		[coordinates[0].x, coordinates[0].y],
		[coordinates[1].x, coordinates[1].y],
		[coordinates[2].x, coordinates[2].y],
		[coordinates[3].x, coordinates[3].y]]

	const feature = new Feature({
		geometry: new Polygon([mappedCoordinates]),
	})

	const featureStyle = new Style({
		stroke: new Stroke({
			color: boundArea.color,
			width: boundArea.borderWidth
		}),
	})

	if (boundArea.fillColor !== undefined)
		featureStyle.setFill(new Fill({ color: boundArea.fillColor, }))

	feature.setStyle(featureStyle)

	return feature
}

export class Layers {

	// public ProduceLayers = (ocr: string): VectorLayer => {

	// }

	// public ProduceTextLayer = (ocr: string): VectorLayer => {

	// }

	// public ProduceResultsLayer = (ocr: string): VectorLayer => {

	// }




}